import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "my-4" }
const _hoisted_3 = { class: "mx-auto" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "text-tertiary text-caption text-sm-body-2 text-md-subtitle-1" }
const _hoisted_6 = { class: "text-tertiary text-caption text-sm-body-2 text-md-subtitle-1" }
const _hoisted_7 = { class: "text-tertiary text-caption text-sm-body-2 text-md-subtitle-1" }
const _hoisted_8 = { class: "text-tertiary text-caption text-sm-body-2 text-md-subtitle-1" }
const _hoisted_9 = { class: "mx-auto" }
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_error_component = _resolveComponent("error-component")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar, {
            app: "",
            absolute: "",
            height: "70",
            color: "#c9d304",
            flat: "",
            class: "position-fixed ma-0"
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_v_img, {
                cover: "",
                style: {"width":"200px","height":"100%"},
                src: _ctx.logo
              }, null, 8, ["src"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "d-none d-md-flex ma-0 pt-4 w-100 align-baseline" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_icon, {
                    color: "#9b267c",
                    size: "22"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-map-marker-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[4] || (_cache[4] = _createElementVNode("small", {
                    style: {"color":"#9b267c"},
                    class: "text-h5 font-weight-medium"
                  }, "Mozambique", -1)),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_icon, {
                    color: "#9b267c",
                    size: "22"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-map-marker-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("small", {
                    style: {"color":"#9b267c"},
                    class: "text-h5 font-weight-medium"
                  }, "Johannesburg", -1)),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_icon, {
                    color: "#9b267c",
                    size: "22"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-map-marker-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[6] || (_cache[6] = _createElementVNode("small", {
                    style: {"color":"#9b267c"},
                    class: "text-h5 font-weight-medium"
                  }, "Lisboa", -1)),
                  _createVNode(_component_v_spacer)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_main, { style: {"height":"100%"} }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, {
                fluid: "",
                class: ""
              }, {
                default: _withCtx(() => [
                  _cache[19] || (_cache[19] = _createElementVNode("h1", { class: "text-sm-h5 text-md-h4 text-center text-primary-dark" }, " Track & Trace ", -1)),
                  (!_ctx.hasData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mb-2 text-primary-dark text-center text-body-1 font-weight-light" }, " Use o seu código de tracking para rastrear o seu correio ou carga. ", -1)),
                        _createVNode(_component_v_row, { class: "ma-0 justify-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              xs: "10",
                              sm: "10",
                              md: "4",
                              lg: "4",
                              class: "py-2 px-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  placeholder: "Código de tracking",
                                  "prepend-inner-icon": "mdi-marker",
                                  variant: "outlined",
                                  color: "primary",
                                  density: "comfortable",
                                  "base-color": "primary-dark",
                                  rounded: "md",
                                  "hide-details": "auto",
                                  modelValue: _ctx.code,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, { class: "ma-0 justify-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              "prepend-icon": "mdi-map-marker-path",
                              color: "primary",
                              variant: "tonal",
                              onClick: _withModifiers(_ctx.trackPackage, ["prevent"])
                            }, {
                              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                _createTextVNode(" Track ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createBlock(_component_v_row, {
                        key: 1,
                        class: "justify-center ma-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { class: "justify-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { class: "justify-center" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        class: "py-1",
                                        "prepend-icon": "mdi-login",
                                        color: "primary",
                                        variant: "tonal",
                                        onClick: _withModifiers(_ctx.newTracking, ["prevent"])
                                      }, {
                                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                          _createTextVNode(" Novo Tracking ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                xs: "12",
                                sm: "12",
                                md: "11",
                                lg: "11",
                                class: "pa-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card, { class: "pa-4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            xs: "12",
                                            sm: "12",
                                            md: "6",
                                            lg: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { class: "text-h6" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(" Ref: " + _toDisplayString(_ctx.myPack?.ref), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "text-body-1" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(" Destinatário: " + _toDisplayString(_ctx.myPack?.client), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "text-body-1" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(" Peso: " + _toDisplayString(_ctx.myPack?.weight) + "Kg ", 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "text-body-1" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(" Data: " + _toDisplayString(_ctx.myPack?.date), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                class: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { class: "text-caption my-4 text-secondary" }, {
                                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                      _createTextVNode(" More Details ", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "text-body-1" }, {
                                                    default: _withCtx(() => [
                                                      _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-black" }, "Rota: ", -1)),
                                                      _createTextVNode(" " + _toDisplayString(_ctx.myPack?.origin) + " - " + _toDisplayString(_ctx.myPack?.destination), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "text-body-1" }, {
                                                    default: _withCtx(() => [
                                                      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-black" }, "Levantamento:", -1)),
                                                      _createTextVNode(" " + _toDisplayString(_ctx.myPack?.pickup), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "text-body-1" }, {
                                                    default: _withCtx(() => [
                                                      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "text-black" }, "Codigo de Levantamento:", -1)),
                                                      _createTextVNode(" " + _toDisplayString(_ctx.myPack?.pickup_code), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "text-body-1" }, {
                                                    default: _withCtx(() => [
                                                      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "text-black" }, "Destinatário:", -1)),
                                                      _createTextVNode(" " + _toDisplayString(_ctx.myPack?.client), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "text-body-1" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, { class: "px-0" }, {
                                                        default: _withCtx(() => [
                                                          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "text-black" }, "Conteudo", -1)),
                                                          _createElementVNode("div", null, _toDisplayString(_ctx.myPack?.content) + ".", 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "text-body-1" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, { class: "px-0" }, {
                                                        default: _withCtx(() => [
                                                          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-black" }, "Descrição", -1)),
                                                          _createElementVNode("div", null, _toDisplayString(_ctx.myPack?.description) + ".", 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            class: "ml-4",
                                            cols: "12",
                                            xs: "12",
                                            sm: "12",
                                            md: "6",
                                            lg: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_timeline, {
                                                "line-color": "primary",
                                                "line-thickness": "2",
                                                align: "center",
                                                density: "compact"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myPack?.tracking, (tracking, i) => {
                                                    return (_openBlock(), _createBlock(_component_v_timeline_item, {
                                                      key: i,
                                                      "dot-color": 
                            tracking.status == true ? 'primary' : 'muted'
                          ,
                                                      "fill-dot": tracking.status == true ? true : false,
                                                      size: "x-small",
                                                      density: "compact",
                                                      height: "80"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_2, [
                                                          _createElementVNode("div", null, [
                                                            _createElementVNode("span", {
                                                              class: _normalizeClass([
                                  tracking.status == true
                                    ? 'text-primary-dark'
                                    : 'text-muted'
                                , "font-weight-black"])
                                                            }, _toDisplayString(tracking.date), 3)
                                                          ]),
                                                          _createElementVNode("div", null, [
                                                            _createElementVNode("span", {
                                                              class: _normalizeClass([
                                  tracking.status == true
                                    ? 'text-primary'
                                    : 'text-muted'
                                , "text-body-1 font-weight-light"])
                                                            }, _toDisplayString(tracking.action), 3),
                                                            _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                                                            _createElementVNode("span", {
                                                              class: _normalizeClass([
                                  tracking.status == true
                                    ? 'text-secondary'
                                    : 'text-muted'
                                , "text-caption font-weight-light"])
                                                            }, _toDisplayString(tracking.point), 3)
                                                          ])
                                                        ])
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["dot-color", "fill-dot"]))
                                                  }), 128))
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        xs: "12",
                        sm: "12",
                        md: "11",
                        lg: "11",
                        class: "mx-auto"
                      }, {
                        default: _withCtx(() => [
                          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-h6 text-sm-h5 text-md-h4 mt-4 mb-2" }, " Perguntas Frequentes ", -1)),
                          _createVNode(_component_v_expansion_panels, { variant: "accordion" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (faq, i) => {
                                return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: i }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_title, {
                                      class: "font-weight-strong",
                                      "expand-icon": "mdi-menu-down"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(faq.quiz), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_expansion_panel_text, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(faq.text), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_footer, {
                app: "",
                height: _ctx.fheight,
                class: "bg-pd-primary px-0 flex-column"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "d-none d-md-flex ma-0 w-100" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "10",
                        class: "py-1 px-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { class: "ma-0" }, {
                            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                              _createElementVNode("span", { class: "text-tertiary" }, " Contactos - Maputo - Sede : Av Acordos de Lusaka, nº 3237 | Tell: +258 82 120 8151 / +258 84 120 8151; ", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, { class: "ma-0" }, {
                            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                              _createElementVNode("span", { class: "text-tertiary" }, [
                                _createTextVNode(" Email: "),
                                _createElementVNode("a", {
                                  class: "text-decoration-none text-tertiary",
                                  href: "mailto:info@portadordiario.co.mz"
                                }, " info@portadordiario.co.mz "),
                                _createTextVNode(", Web: "),
                                _createElementVNode("a", {
                                  class: "text-decoration-none text-tertiary",
                                  href: "https://www.portadordiario.co.mz"
                                }, "www.portadordiario.co.mz")
                              ], -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { class: "" }, {
                            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                              _createElementVNode("span", { class: "mx-auto text-tertiary" }, " Siga-nos ", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon, i) => {
                                  return (_openBlock(), _createElementBlock("a", {
                                    key: i,
                                    href: icon.link,
                                    target: "_blank",
                                    class: "text-decoration-none text-white"
                                  }, [
                                    _createVNode(_component_v_icon, {
                                      color: "White",
                                      size: _ctx.isize
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(icon.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["size"])
                                  ], 8, _hoisted_4))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "d-md-none ma-0 w-100" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "10",
                        class: "pa-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { class: "ma-0" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_5, [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                    _createTextVNode("mdi-phone", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[24] || (_cache[24] = _createTextVNode(" +258 82 120 8151 / +258 84 120 8151; ", -1))
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, { class: "ma-0" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_6, [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                    _createTextVNode("mdi-map-marker", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[26] || (_cache[26] = _createTextVNode(" Maputo - Sede: Av Acordos de Lusaka, nº 3237 ", -1))
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, { class: "ma-0" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_7, [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                    _createTextVNode("mdi-email", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[28] || (_cache[28] = _createElementVNode("a", {
                                  class: "text-decoration-none text-tertiary",
                                  href: "mailto:info@portadordiario.co.mz"
                                }, " info@portadordiario.co.mz ", -1))
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, { class: "ma-0" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_8, [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                    _createTextVNode("mdi-web", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[30] || (_cache[30] = _createElementVNode("a", {
                                  class: "text-decoration-none text-tertiary",
                                  href: "https://www.portadordiario.co.mz"
                                }, " www.portadordiario.co.mz", -1))
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { class: "" }, {
                            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                              _createElementVNode("span", { class: "mx-auto text-caption text-sm-body-2 text-tertiary" }, " Siga-nos ", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon, i) => {
                                  return (_openBlock(), _createElementBlock("a", {
                                    key: i,
                                    href: icon.link,
                                    target: "_blank",
                                    class: "text-decoration-none text-white"
                                  }, [
                                    _createVNode(_component_v_icon, {
                                      color: "White",
                                      size: _ctx.isize
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(icon.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["size"])
                                  ], 8, _hoisted_10))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _cache[32] || (_cache[32] = _createElementVNode("div", {
                    class: "bg-tertiary",
                    style: {"height":"6px","width":"100%","margin-bottom":"4px","margin-top":"4px"}
                  }, null, -1)),
                  _createVNode(_component_v_divider)
                ]),
                _: 1
              }, 8, ["height"]),
              _createVNode(_component_error_component, {
                dialog: _ctx.errorDialog,
                message: _ctx.errorMsg,
                onClose: _ctx.closeErrorDialog
              }, null, 8, ["dialog", "message", "onClose"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}